import CheckboxOptionItem, { CheckboxOptionItemProps } from './CheckboxOptionItem';

export type { CheckboxOptionItemProps };
export default CheckboxOptionItem;
